module.exports = __webpack_public_path__ + "img/image_2.150c8a46.jpg";